import moment from 'moment';
import { DEFAULT_DATE_FORMAT } from '@/utils/helpers';

export default {
  props: {
    documentData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      openedIndexes: [],
    };
  },
  methods: {
    parseDate(document) {
      if (document.displayDocumentCreatedDate) {
        return moment(document.displayDocumentCreatedDate).format(DEFAULT_DATE_FORMAT);
      }
      return '-';
    },
    onOpen(document, index) {
      this.openedIndexes.push(index);
      window.open(document.displayDocumentPath);
    },
    rowClassModifiers(document, index) {
      return {
        'document-table-view__row': true,
        'document-table-view__row--clickable': true,
        'document-table-view__row--opened': this.openedIndexes.includes(index),
      };
    },
  },
};
